"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
import { LOGO_MARK, LOGO_VIEWBOX } from "../internal/logoMark.js";
/** The Jaiora mark — the same drawing as jaiora.me (public/logo.svg). */
export function Logo({ size = 28, variant = "color", label, className }) {
    return _jsx("svg", { viewBox: LOGO_VIEWBOX, height: size, width: Math.round(size * 92 / 76), fill: "none", className: cx("jui-logo", variant === "mono" && "jui-logo--mono", className), role: label ? "img" : undefined, "aria-label": label, "aria-hidden": label ? undefined : true, dangerouslySetInnerHTML: { __html: LOGO_MARK } });
}
